// Central, verified company facts. Anything not yet confirmed is marked
// with a bracketed placeholder — search the codebase for "[ADD" / "[VERIFY"
// before launch to find every field that still needs real data.

const companyData = {
  name: 'PROVIRTUES',
  legalName: 'SHRI HARI COMPUTER SERVICES LLC',
  dbaNotice: 'PROVIRTUES is a DBA (trade name) of SHRI HARI COMPUTER SERVICES LLC, registered in Maryland.',
  tagline: 'Your Accountable Technology Delivery Partner',
  valueProposition:
    'PROVIRTUES helps organizations increase technology delivery capacity, complete critical initiatives, ' +
    'modernize applications, and fill skill gaps through accountable IT consulting, software development, ' +
    'managed delivery, and flexible staff augmentation.',

  email: 'info@provirtues.net',
  hours: 'Mon – Sat, 9am – 6pm',
  city: 'Baltimore',
  state: 'Maryland',
  headquarters: 'Maryland, USA',
  serviceArea: 'United States',

  experienceStatement: '24+ years of software development and SDLC leadership experience',
  experienceStatementShort: '24+ years of SDLC leadership experience',

  founder: {
    name: 'Ravi Patel',
    background:
      'a background in Computer Engineering and an MBA, with more than 24 years of hands-on experience ' +
      'across the software development life cycle — planning, architecture, development, testing, ' +
      'deployment, modernization, and production support.',
  },

  social: {
    linkedin: 'https://www.linkedin.com/company/provirtues',
  },

  // Government / prime-contractor procurement data, published on
  // /government-subcontracting. Readiness statuses below are asserted by the
  // business; the bracketed [ADD ...] fields are real IDs/numbers still to be
  // filled in — replace them as registrations are confirmed.
  procurement: {
    legalBusinessName: 'SHRI HARI COMPUTER SERVICES LLC',
    dba: 'PROVIRTUES',
    businessType: 'Limited Liability Company (LLC) — SBA Small Business',
    headquarters: 'Maryland, USA',
    serviceArea: 'United States',
    uei: 'H4FDT4J6LUY9',
    cageCode: '23CS6',
    // Legacy identifier — retired federally by SAM.gov in 2022 in favor of
    // the UEI above, but some state/local systems still reference it.
    duns: '12-135-8524',
    samStatus: 'Active',
    // Federal Tax ID (EIN) is deliberately NOT published here: it's not
    // needed for vendor qualification (UEI/CAGE/SAM.gov status cover that),
    // and publishing it publicly is a recognized business-identity-theft
    // risk per PTAC/GSA guidance. Provided directly via W-9 on request.
    naicsCodes: [
      { code: '541511', label: 'Custom Computer Programming Services' },
      { code: '541512', label: 'Computer Systems Design Services' },
      { code: '541513', label: 'Computer Facilities Management Services' },
      { code: '541519', label: 'Other Computer Related Services' },
      { code: '518210', label: 'Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services' },
    ],
    pscCodes: [
      { code: 'DA01', label: 'Business Application / Application Development Support Services' },
      { code: 'DG01', label: 'Network Support Services' },
      { code: 'DF01', label: 'IT Management Support Services' },
      { code: 'DA10', label: 'Business Application / Application Development SaaS' },
    ],
    // State & local vendor registrations — each with the registration/ID
    // reference a contracting officer would ask to confirm.
    stateRegistrations: [
      { name: 'Maryland eMMA', detail: 'Registered Supplier · ID SUP1104130', status: 'ready' },
      { name: "Prince George's County, MD", detail: 'BNO-100000181038570 · ANID AN11476461100', status: 'ready' },
      { name: 'Commonwealth of Pennsylvania', detail: 'Vendor ID 572219', status: 'ready' },
      { name: 'Maryland SBE (Small Business Enterprise)', detail: 'Application in process', status: 'pending' },
      { name: 'Maryland MBE (Minority Business Enterprise)', detail: 'Application in process', status: 'pending' },
    ],
    certifications: '[ADD VERIFIED CERTIFICATIONS]',
    contractVehicles: '[ADD VERIFIED CONTRACT VEHICLES]',
    pointOfContact: '[USE VERIFIED POINT OF CONTACT]',

    // Readiness checklist shown on the Government page and the homepage
    // teaser. `pending` items render with an in-progress state instead of a
    // checkmark — update the status once the item is confirmed.
    readiness: [
      { label: 'SAM.gov Registered', status: 'ready', note: 'Active' },
      { label: 'Unique Entity ID (UEI)', status: 'ready' },
      { label: 'CAGE Code', status: 'ready' },
      { label: 'Maryland eMMA Registered Supplier', status: 'ready' },
      { label: "Prince George's County, MD Registered Vendor", status: 'ready' },
      { label: 'Commonwealth of PA Registered Vendor', status: 'ready' },
      { label: 'Maryland Small Business Enterprise (SBE)', status: 'pending', note: 'Application in process' },
      { label: 'Maryland Minority Business Enterprise (MBE)', status: 'pending', note: 'Application in process' },
      { label: 'SBA Small Business', status: 'ready' },
      { label: 'Federal Contractor Ready', status: 'ready' },
      { label: 'State & Local Procurement Ready', status: 'ready' },
    ],
  },
};

export default companyData;
